import { useTranslation } from 'react-i18next';
import { QButton, QButtonGroup, QHeader, QTitle } from '@qualio/ui-components';
import { useState } from 'react';
import { useUserPermissions } from '../../../../hooks';
import { EventNewModal } from '../../../../components';
import { useSearchParams } from 'react-router-dom';
import ExportButton from '../EventListExport/ExportButton';

const EventListHeader = () => {
  const { t } = useTranslation();
  const { canCreateEvent } = useUserPermissions();
  const [searchParams] = useSearchParams();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(!!searchParams.get('open_modal'));
  const isTasksTab = searchParams.get('tab') === 'tasks';

  return (
    <>
      <QHeader showDivider={false}>
        <QTitle data-cy="event-list-header-title">{t('common.labels.events')}</QTitle>
        <QButtonGroup>
          {!isTasksTab && <ExportButton />}
          {canCreateEvent && (
            <QButton variant="solid" onClick={() => setIsModalOpen(true)} data-metrics="create-event-button">
              {t('events.actions.createEvent')}
            </QButton>
          )}
        </QButtonGroup>
      </QHeader>

      {isModalOpen && <EventNewModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />}
    </>
  );
};

export default EventListHeader;
